<template>
  <div class="sms-confirm">
    <form-item
      class="sms-confirm__form-item"
      label="Код подтверждения"
      text-after="На указанный вами номер отправлен код"
      :is-bold-label="true"
      :text-error="errorSendReceivedCode"
    >
      <input-control
        v-model="value"
        inputmode="tel"
      />
    </form-item>
    <form-item class="sms-confirm__form-item">
      <button-control
        :loading="isSendingCode"
        :is-block="true"
        @click="sendReceivedCodeMethod"
      >
        Отправить
      </button-control>
    </form-item>
    <form-item class="sms-confirm__form-item no-mb">
      <vue-countdown
        v-show="!isMaySendAnotherCode"
        ref="countdown"
        :time="Number(timeLeft)"
        class="sms-confirm__countdown"
        :auto-start="false"
        @end="isMaySendAnotherCode = true"
      >
        <template slot-scope="props">
          Отправить код повторно можно через:
          {{ props.minutes }}
          {{ props.minutes | plural(['минута', 'минуты', 'минут']) }},
          {{ props.seconds }}
          {{ props.seconds | plural(['секунда', 'секунды', 'секунд']) }}
        </template>
      </vue-countdown>
      <button
        v-if="isMaySendAnotherCode"
        href="#"
        class="link _dashed"
        @click.prevent="sendCode"
      >
        Отправить код повторно
      </button>
    </form-item>
  </div>
</template>

<script>
import { InputControl, FormItem, ButtonControl } from '@book24/ui-components';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { onMounted } from '@vue/composition-api';

import useSmsConfirm from '@/js/vue/_composition/useSmsConfirm';

export default {
  name: 'SmsConfirm',
  components: {
    InputControl,
    FormItem,
    ButtonControl,
    VueCountdown,
  },
  props: {
    phone: {
      default: '',
      type: String,
    },
  },
  setup(props, context) {
    const smsConfirm = useSmsConfirm(props, context);

    onMounted(() => {
      smsConfirm.sendCode();
    });

    return {
      ...smsConfirm,
    };
  },
};
</script>
